import React, { Component } from 'react'

export class NotFound extends Component {
  render() {
    return (
      <h1>404 Page not found</h1>
    )
  }
}

export default NotFound